/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsSidebar = {
  init() {
    /*
     * Faceted filter submission is owned by faceted-filter-dropdown.js
     * (delegated submit handler on document). It intercepts submit on
     * any [data-faceted-filter-form], rebuilds URL preserving non-filter
     * params, and navigates. This avoids racing with the explicit
     * "Filter anwenden" button and keeps mobile/desktop logic unified.
     */

    // Exclude <summary> elements — those live inside <details> and have native toggle.
    // Without this, clicks on faceted-filter summaries trigger BOTH the native
    // <details> toggle AND slideToggle, leaving content invisible.
    $('.sidebar-block__heading').not('summary').on('click', function() {
      const $content = $(this).next('.sidebar-block__content');
      $content.slideToggle();
      $(this).toggleClass('is-open');
    });

    // --- FIX: Alle collapsible Blöcke initial einklappen ---
    $('[data-sidebar-block__content--collapsible]').each(function() {
      const $content = $(this);
      const $header = $content.siblings('.sidebar-block__heading');
      if (!$header.attr('data-sidebar-block__toggle')) {
        $header.attr('data-sidebar-block__toggle', 'closed');
      }
      $content.hide();
    });

    // Initial geöffnete Blöcke (falls vorhanden)
    const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');
    openSidebarBlocks.forEach(block => {
      window.PXUTheme.jsSidebar.openSidebarBlock($(block));
    });

    // Header klickbar machen
    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="closed"]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsSidebar.openSidebarBlock($(this));
    });

    $('[data-has-toggle-option]').on('click', '[data-sidebar-block__toggle="open"]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsSidebar.closeSidebarBlock($(this));
    });

    if ($('[data-product-sidebar]').length) {
      $('.section--has-sidebar-option').addClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').removeClass('has-sidebar-disabled');
    } else {
      $('.section--has-sidebar-option').removeClass('has-sidebar-enabled');
      $('.section--has-sidebar-option').addClass('has-sidebar-disabled');
    }
  },

  openSidebarBlock($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');
    $toggleBtn.attr('data-sidebar-block__toggle', 'open');
    $parentBlock.addClass('is-active');
    $parentBlock.attr('aria-expanded', true);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideDown();
  },

  closeSidebarBlock($toggleBtn) {
    const $parentBlock = $toggleBtn.closest('.sidebar__block');
    $toggleBtn.attr('data-sidebar-block__toggle', 'closed');
    $parentBlock.removeClass('is-active');
    $parentBlock.attr('aria-expanded', false);
    $parentBlock.find('[data-sidebar-block__content--collapsible]').slideUp();
  },

  unload() {
    const $toggleBtn = $('[data-sidebar-block__toggle]');
    $toggleBtn.off();
  },
};

/******/ })();
